/**
 * DysonLogo — back-compat wrapper around :class:`DysonSphere`.
 *
 * Kept so existing callers (Sidebar, NavigationBar, Wordmark, etc.)
 * don't have to change shape. New code should import ``DysonSphere``
 * directly and pick a ``mode``.
 *
 * Spec: Docs/design/12-logo-and-wordmark.md.
 */
import { DysonSphere } from "./DysonSphere";

interface DysonLogoProps {
  className?: string;
  /** Skip self-hover tracking and force-animate from parent. */
  active?: boolean;
}

export function DysonLogo({ className, active }: DysonLogoProps) {
  return (
    <DysonSphere
      mode={active ? "listening" : "idle"}
      hoverActivates={!active}
      className={className}
    />
  );
}
